import cachingMechanisum from 'components/Common/cachingMechanisum';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import trackServices from './trackServices';
import { CommonUtilities } from 'commonUtils';
import { ContactFormSearch } from 'components/Contacts/contactFormSearch';


export default function TrackDetailsForm(param: any) {

    console.log(param)
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(1);
    const [imprintList, initimprintListt] = useState<any>([]);
    const closeDrawer = () => { param.onChangTrackDetailsForm(); }

    let [trackDetailsEdit, setTrackDetailsEdit] = useState<any>([]);

    useEffect(() => {

        if (param.TrackDetailsOpen) {
            var imprintList = cachingMechanisum.getCachingStorage("labelList");
            initimprintListt(imprintList)

            if (param?.TrackDetailSelect) {
                trackDetailsEdit = param?.TrackDetailSelect;
                setTrackDetailsEdit(trackDetailsEdit)

                if (param?.TrackDetailSelect?.trackDuration) {
                    console.log(param?.TrackDetailSelect?.trackDuration)
                    const [hours, minutes, seconds] = param?.TrackDetailSelect?.trackDuration?.split(":");

                    setHours(hours)

                    setMinutes(minutes)

                    setSeconds(seconds)
                }
            }
        }


    }, []);


    const pad = (num: any) => String(num).padStart(2, "0");

    const increase = (setter: any, value: any, max: any): any => {
        setter(value < max ? value + 1 : 0);
    };

    const decrease = (setter: any, value: any, max: any) => {
        setter(value > 0 ? value - 1 : max);
    };


    const saveTrackDetails = () => {

        if (inputFieldValidation()) {
            console.log("inputFieldValidation")
            trackServices.trackSave(trackDetailsEdit).then((respond: any) => {
                trackDetailsEdit = respond
                if (respond) {
                    CommonUtilities.showToastDawer('Track Details has been saved successfully', 'Success')
                }
            })

        } else {
            CommonUtilities.showToastDawer('There was a problem submitting your request, one or more fields are missing or incorrect', 'fail')
        }

    }

    const inputFieldValidation = () => {
        var checkStatus = true;
        console.log(trackDetailsEdit)
        const label: any = document.getElementById("label");
        const intStdRecCode: any = document.getElementById("intStdRecCode");
        const titleVersion: any = document.getElementById("titleVersion");
        const artistDisplay: any = document.getElementById("artistDisplay");

        if (!trackDetailsEdit?.label || trackDetailsEdit?.label === null || trackDetailsEdit?.label?.length == 0) {
            label.style.border = "1px solid #e50e0e";
            checkStatus = false;
        }

        if (!trackDetailsEdit.intStdRecCode || trackDetailsEdit?.label === null || trackDetailsEdit?.intStdRecCode?.length == 0) {
            intStdRecCode.style.border = "1px solid #e50e0e";
            checkStatus = false;
        }

        if (!trackDetailsEdit.titleVersion || trackDetailsEdit?.titleVersion === null || trackDetailsEdit?.titleVersion?.length == 0) {
            titleVersion.style.border = "1px solid #e50e0e";
            checkStatus = false;
        }

        if (!trackDetailsEdit.artist || trackDetailsEdit?.artist === null || trackDetailsEdit?.artist?.length == 0) {
            artistDisplay.style.border = "1px solid #e50e0e";
            checkStatus = false;
        }

        setTimeout(function () {
            label.style.border = "1px solid #dedede";
            intStdRecCode.style.border = "1px solid #dedede";
            artistDisplay.style.border = "1px solid #dedede";
            titleVersion.style.border = "1px solid #dedede";
        }, 2000);

        return checkStatus;
    }

    const ResetTrackDetails = () => {
        trackDetailsEdit = param?.TrackDetailSelect;
        setTrackDetailsEdit(trackDetailsEdit)

        if (param?.TrackDetailSelect?.trackDuration) {
            console.log(param?.TrackDetailSelect?.trackDuration)
            const [hours, minutes, seconds] = param?.TrackDetailSelect?.trackDuration?.split(":");

            setHours(hours)

            setMinutes(minutes)

            setSeconds(seconds)
        }
    }

    let [fileUpload, setFileUpload] = useState<any>([]);
    const uploadSoundFile = (event: any) => {

        var fileName = event?.target?.files[0];
        console.log(fileName)
        console.log(trackDetailsEdit)


        const type = fileName?.type || "";


        if (event?.target?.files) {
            setFileUpload(fileName)
            fileName = URL.createObjectURL(fileName)
        }

        if (type.includes("wav")) {
            console.log("wav");
            trackServices.uploadSound(fileUpload, trackDetailsEdit?.iSRC, trackDetailsEdit?.trackName)
        }

        if (type.includes("mpeg")) {
            console.log("mp3");
            trackServices.uploadSound(fileUpload, trackDetailsEdit?.iSRC, trackDetailsEdit?.trackName)
        }

        if (type.includes("mp4")) {
            console.log("mp4");
            trackServices.uploadSound(fileUpload, trackDetailsEdit?.iSRC, trackDetailsEdit?.trackName)
        }

    }


    let [kontactDisplay, setkontactDisplay] = useState("");
    let [dialogueAddOpenView, setdialogueAddOpenView] = useState(false);
    const onChangeContact = (e: any) => {
        console.log(e)

        setTrackDetailsEdit({ ...trackDetailsEdit, artist: e?.kontactCode })

        setdialogueAddOpenView(false)
        setkontactDisplay(e?.kontactCode ? e?.kontactDisplay + ' (' + e?.kontactCode + ')' : '');
    }

    const generateISRC = () => {
        trackServices.generateItem(trackDetailsEdit).then((respond: any) => {
            setTrackDetailsEdit({ ...trackDetailsEdit, iSRC: respond.intStdRecCode })
        })
    }

    return (<>

        <Drawer
            open={param.TrackDetailsOpen}
            onClose={closeDrawer}
            direction='right'
            className='react-drawer allowHscroll allowVscroll'
            size={800}>

            <div className="box ws-7 pull-right">

                <div className="ws-12 box-header-main">
                    <h1 className="mlxl pull-left text-center">Track Link Details</h1>
                </div>

                <div className="ws-12 pm">

                    <fieldset className="scheduler-border ws-12" style={{ marginLeft: "15% !important" }}>

                        <legend className="scheduler-border"><h2 style={{ color: "#47529d" }} >
                            <i className="fa fa-sticky-note-o"></i> Track Info</h2>

                        </legend>

                        <div className="ws-12">

                            <div className="form-format m0 mb ws-6">
                                <label className="control-label"> Track Name</label>
                                <div className="label-entries">
                                    <input id="trackName" value={trackDetailsEdit.trackName ?? ""} type="text" placeholder="Enter Track Name" onChange={(e: any) => setTrackDetailsEdit({ ...trackDetailsEdit, trackName: e.target.value })} />
                                </div>
                            </div>

                            <div className="form-format m0 mb ws-6">
                                <label className="control-label">Track Artist*</label>
                                <div className="ws-12">
                                    <input type="text" className="w-79" value={trackDetailsEdit.artist ?? ""} id="artistDisplay" readOnly required />
                                    <ContactFormSearch onChange={onChangeContact} data={""} open={dialogueAddOpenView} />

                                </div>
                            </div>
                        </div>

                        <div className="ws-12">
                            <div className="ws-6 form-format  m0 mb">
                                <label className="control-label">Label*</label>
                                <div className="label-entries">
                                    <select value={trackDetailsEdit.label ?? ""} name="label" id="label" required onChange={(e: any) => setTrackDetailsEdit({ ...trackDetailsEdit, label: e.target.value })}>
                                        <option value="" >Choose a Label</option>
                                        {
                                            imprintList?.map((values: any) => {
                                                return (
                                                    <option value={values.companyName} label={values.companyName}>{values.companyName}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>

                            <div className="form-format ws-6 m0 mb">
                                <label className="control-label">ISRC*</label>

                                <div className="label-entries">
                                    <div className="w-58">
                                        <input id="intStdRecCode" value={trackDetailsEdit.iSRC ?? ""} type="text" name="intStdRecCode" placeholder="Enter ISRC" ng-required="true"  required />
                                    </div>
                                    <div className="w-37">
                                        <button type="button" className="icon-btn warning height35" onClick={generateISRC}> Generate ISRC</button>
                                    </div>
                                    <div className="w-2 mt">
                                        <label className="switch m0">
                                            <input type="checkbox" title="Generate ISRC using 1st available date" value={trackDetailsEdit.genISRCByDate ?? ""} onChange={(e: any) => setTrackDetailsEdit({ ...trackDetailsEdit, genISRCByDate: e.target.value })} />
                                            {trackDetailsEdit.genISRCByDate == 1 && <span className="slider round text-left white pm pts">Yes</span>}
                                            {trackDetailsEdit.genISRCByDate != 1 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                        </label>

                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="ws-12">
                            <div className="ws-6 form-format  m0 mb">
                                <label className="control-label" >Version*</label>
                                <div className="label-entries">
                                    <input id="titleVersion" value={trackDetailsEdit.titleVersion ?? ""} type="text" name="trackTitle" onChange={(e: any) => setTrackDetailsEdit({ ...trackDetailsEdit, titleVersion: e.target.value })} placeholder="Enter Version" required />
                                </div>
                            </div>

                            <div className="ws-6 form-format  m0 mb">
                                <label className="control-label" >1st Available</label>
                                <div className="label-entries">
                                    <input value={trackDetailsEdit.trackFirstAvailableDate ?? ""} onChange={(e: any) => setTrackDetailsEdit({ ...trackDetailsEdit, trackFirstAvailableDate: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="ws-12">
                            <div className="ws-6 form-format m0 mb">
                                <label className="control-label" > Duration </label>

                                <div className='ws-12'>
                                    <div className='ws-6'>
                                        <div className='ws-12'>
                                            {/* Hours */}
                                            <div className='ws-3'>
                                                <button onClick={() => increase(setHours, hours, 23)} className="ws-12 icon-btn info">▲</button>
                                                <div className="ws-12 text-center">{pad(hours)}</div>
                                                <button onClick={() => decrease(setHours, hours, 23)} className="ws-12 icon-btn info">▼</button>
                                            </div>

                                            <span className='ws-1 mtxl text-center pt text-bold'>:</span>

                                            {/* Minutes */}
                                            <div className='ws-3'>
                                                <button onClick={() => increase(setMinutes, minutes, 59)} className="ws-12 icon-btn info">▲</button>
                                                <div className="ws-12 text-center">{pad(minutes)}</div>
                                                <button onClick={() => decrease(setMinutes, minutes, 59)} className="ws-12 icon-btn info">▼</button>
                                            </div>

                                            <span className='ws-1 mtxl text-center pt text-bold'>:</span>

                                            {/* Seconds */}
                                            <div className='ws-3'>
                                                <button onClick={() => increase(setSeconds, seconds, 59)} className="ws-12 icon-btn info">▲</button>
                                                <div className="ws-12 text-center">{pad(seconds)}</div>
                                                <button onClick={() => decrease(setSeconds, seconds, 59)} className="ws-12 icon-btn info">▼</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </fieldset >

                </div>

                <div className="ws-12 pm">
                    <label className="icon-btn info width100 height35 pull-right" ng-show="trackDetailsEdit.trackId">
                        <i className="icon-file-add"></i> Add File
                        <input type="file" accept=".wav,.mp3,.mp4" ngf-select="" ng-model="file" ng-accept=".wav,.mp3,.mp4" onChange={uploadSoundFile} className='hide' />
                    </label>

                    <button className="icon-btn edit width80 height35 pull-right" onClick={saveTrackDetails}>
                        <i className="icon-save"></i> Save
                    </button>

                    <button className="icon-btn delete width80 height35 pull-right" onClick={ResetTrackDetails}>
                        <i className="icon-reload"></i> Reset
                    </button>

                    <button className="icon-btn delete width80 height35 pull-right" onClick={closeDrawer}><i className="fa fa-close"></i> Close  </button>

                </div>

            </div >

        </Drawer >
    </>)

}